"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contests_constants_1 = require("@biw/contests-constants");
var getIsAverageOrReduction = function (pct) { return pct === 'reduction' || pct === 'average'; };
var getIsOver100 = function (otp, pp) { return otp > 99 && pp > 99; };
var getIsFinal = function (pvs) { return pvs === contests_constants_1.PVS__FINAL_ISSUANCE; };
// Need to strict check for false as a null or undefined really means true
var getIsMinQualifierSuccess = function (isMinQualifierAchieved) { return isMinQualifierAchieved !== false; };
// these values are often used as props, important to maintain object reference
var GET_GOING = { className: 'get-going', label: 'progress.getGoing' };
var STAY_FOCUSED = { className: 'stay-focused', label: 'progress.stayFocused' };
var SORTA = { className: 'sorta', label: 'progress.sorta' };
var ON_TRACK = { className: 'on-track', label: 'progress.onTrackHeader' };
var MADE_IT_PROGRESS = { className: 'made-it', label: 'progress.madeIt' };
var MADE_IT_FINAL = { className: 'made-it', label: 'progress.youDidIt' };
var GET_GOING_MISSED = { className: 'get-going', label: 'progress.missedGoal' };
var STAY_FOCUSED_MISSED = { className: 'stay-focused', label: 'progress.missedYourMQ' };
var getProgressStatusTreatment = function (onTrackPercentage, programViewStatus, progressPercentage, programCalculationType, isMinQualifierAchieved) {
    if (onTrackPercentage === void 0) { onTrackPercentage = 0; }
    if (progressPercentage === void 0) { progressPercentage = 0; }
    var isFinal = getIsFinal(programViewStatus);
    var isOver100 = getIsOver100(onTrackPercentage, progressPercentage);
    var isAverageOrReduction = getIsAverageOrReduction(programCalculationType);
    var isMinQualifierSuccess = getIsMinQualifierSuccess(isMinQualifierAchieved);
    switch (true) {
        case onTrackPercentage < 60 && !isFinal:
            return GET_GOING;
        case onTrackPercentage > 59 && onTrackPercentage < 80 && !isFinal:
            return STAY_FOCUSED;
        case onTrackPercentage > 79 && onTrackPercentage < 100 && !isFinal:
            return SORTA;
        case onTrackPercentage > 99 && progressPercentage < 100 && !isFinal:
        case isOver100 && !isFinal && isAverageOrReduction:
            return ON_TRACK;
        case isOver100 && !isFinal && !isAverageOrReduction && isMinQualifierSuccess:
            return MADE_IT_PROGRESS;
        case isOver100 && !isFinal && !isAverageOrReduction && !isMinQualifierSuccess:
            return ON_TRACK;
        case isFinal && progressPercentage < 100:
            return GET_GOING_MISSED;
        case isFinal && progressPercentage > 99 && !isMinQualifierSuccess:
            return STAY_FOCUSED_MISSED;
        case isFinal && progressPercentage > 99 && isMinQualifierSuccess:
            return MADE_IT_FINAL;
        default:
            return STAY_FOCUSED;
    }
};
exports.default = getProgressStatusTreatment;
//# sourceMappingURL=get-progress-status-treatment.js.map